import { useState } from "react";
import { Helmet } from "react-helmet-async";
import styled, { css } from "styled-components";
import { useLocation } from "react-router-dom";
import BannerSection from "../components/BannerSection";
import CloudHero from "./HeroSection/Cloud";
import OSSHero from "./HeroSection/OSS";
import FAQ from "./FAQ";
import CloudPricing from "./Plans/Cloud";
import OSSPricing from "./Plans/OSS";
import { ToggleSwitch, ToggleSwitchItem, IToggleSwitchProps } from "@beamcloud/design-system";

import TestimonialSection from "./TestimonialsSection";

const Pricing = () => {
  const [toggleValue, setToggleValue] = useState<any>("cloud");

  const location = useLocation();

  const handleToggleValue = () => {
    setToggleValue(toggleValue == "cloud" ? "oss" : "cloud");
    return;
  };

  return (
    <>
      <Helmet>
        <title>Pricing • Beam</title>
        <link rel="canonical" href={`${window.location.origin}${location.pathname}`} />
        <meta
          name="description"
          content={
            "Run AI workloads anywhere with zero complexity. One line of Python, global GPUs, full control."
          }
        />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`Pricing • Beam`} />
        <meta
          property="og:description"
          content={
            "Run AI workloads anywhere with zero complexity. One line of Python, global GPUs, full control."
          }
        />
        <meta property="og:image" content={"https://www.beam.cloud/meta-hero.png"} />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:title" content={`Pricing • Beam`} />
        <meta
          name="twitter:description"
          content={
            "Run AI workloads anywhere with zero complexity. One line of Python, global GPUs, full control."
          }
        />
        <meta name="twitter:image" content={"https://www.beam.cloud/meta-hero.png"} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <SwitchContainer>
        <ToggleSwitch value={toggleValue} onValueChange={handleToggleValue}>
          <ToggleSwitchItem value="cloud">Cloud</ToggleSwitchItem>
          <ToggleSwitchItem value="oss">Self-Host</ToggleSwitchItem>
        </ToggleSwitch>
      </SwitchContainer>
      {toggleValue == "cloud" ? (
        <>
          <CloudHero />
          <CloudPricing />
        </>
      ) : (
        <>
          <OSSHero />
          <OSSPricing />
        </>
      )}

      <TestimonialSection />
      <FAQ />
      <BannerSection />
    </>
  );
};

export default Pricing;

const SwitchContainer = styled.div`
  display: flex;
  margin: auto;
  width: 100%;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 50px;
`;
